import React from 'react';
import { RouterContext } from '../context';
import { useCurrentStateAndParams } from './useCurrentState';
export function useRouter() {
  const current = useCurrentStateAndParams();
  const context = React.useContext(RouterContext);
  const {
    router
  } = context;
  return {
    states: context.states,
    /**
     * Directly calls router in controller
     */
    go: context.go,
    /**
     * Directly calls router in controller
     */
    reload: context.reload,
    /**
     * Please note that state params can not be inherited from the current state
     * since the router in react is not aware of the current state.
     */
    href(state, params, options) {
      const {
        inherit = true
      } = options;
      return router.stateService.href(state, {
        ...(inherit ? current.params : {}),
        scrollToTop: isAnotherComponent(),
        ...params
      }, options);
      function isAnotherComponent() {
        try {
          var _from$data, _to$data;
          const to = router.stateRegistry.get(state);
          const from = router.stateRegistry.get(current.state.name);
          return (from == null || (_from$data = from.data) == null ? void 0 : _from$data.sectionId) !== (to == null || (_to$data = to.data) == null ? void 0 : _to$data.sectionId);
        } catch (_unused) {
          return false;
        }
      }
    }
  };
}
//# sourceMappingURL=useRouter.js.map